/**
 * Alert config — Prompt.md §18, §21.
 */

import type { PostureIssueType } from "@studystraight/shared-types";

export interface AlertConfig {
  /** §21 — cooldown chung sau mỗi alert (20–30 giây). */
  cooldownMs: number;

  /**
   * Cooldown riêng cho từng loại lỗi.
   * §21 chỉ nói cooldown chung, nhưng với trẻ em việc nghe lặp *cùng một câu* 3 lần trong
   * 90 giây là nguyên nhân số một khiến trẻ tắt app. Nên mỗi issue có thêm cooldown dài hơn.
   */
  perIssueCooldownMs: number;

  /**
   * §21 — "nếu có nhiều lỗi cùng lúc: chỉ chọn lỗi có severity cao nhất".
   * Khi severity bằng nhau, thứ tự này quyết định. TOO_CLOSE đứng đầu vì nó liên quan trực
   * tiếp đến thị lực và là issue duy nhất đo được tin cậy ở CẢ HAI placement — nhờ vậy thứ tự
   * ưu tiên không phải đổi theo mode (quyết định #19).
   */
  severityPriority: readonly PostureIssueType[];

  /** Chặn trường hợp bệnh lý: baseline sai làm hệ thống nhắc liên tục cả phiên. */
  maxAlertsPerSession: number;

  /** Rung (nếu thiết bị hỗ trợ) — iOS không hỗ trợ, adapter tự no-op (§19). */
  vibrationPattern: readonly number[];
}

export const defaultAlertConfig: AlertConfig = {
  cooldownMs: 25_000,
  perIssueCooldownMs: 60_000,
  severityPriority: ["TOO_CLOSE", "HEAD_DOWN", "LEANING_FORWARD", "SHOULDER_TILT"],
  maxAlertsPerSession: 30,
  vibrationPattern: [120, 80, 120],
};
